import { IPoint2d } from '@/editor/math/IPoint2d';
import { EDoorWindowType } from './model';

const FAN_THICKNESS = 60;
export function getDoorWindowBgOutline(width: number, thickness: number) {
  const outline: IPoint2d[] = [];
  outline.push({ x: -width / 2, y: -thickness / 2 });
  outline.push({ x: width / 2, y: -thickness / 2 });
  outline.push({ x: width / 2, y: thickness / 2 });
  outline.push({ x: -width / 2, y: thickness / 2 });
  return outline;
}

export function getSingleDoorSpecificOutline(width: number) {
  const specificOutline: IPoint2d[][] = [];
  const rightShapePath: IPoint2d[] = [];
  rightShapePath.push({ x: width / 2 - FAN_THICKNESS, y: 0 });
  rightShapePath.push({ x: width / 2, y: 0 });
  rightShapePath.push({ x: width / 2, y: width });
  rightShapePath.push({ x: width / 2 - FAN_THICKNESS, y: width });
  specificOutline.push(rightShapePath);

  return specificOutline;
}

export function getDoubleDoorSpecificOutline(width: number) {
  const specificOutline: IPoint2d[][] = [];
  const leftShapePath: IPoint2d[] = [];
  leftShapePath.push({ x: -width / 2 + FAN_THICKNESS, y: 0 });
  leftShapePath.push({ x: -width / 2, y: 0 });
  leftShapePath.push({ x: -width / 2, y: width / 2 });
  leftShapePath.push({ x: -width / 2 + FAN_THICKNESS, y: width / 2 });
  specificOutline.push(leftShapePath);

  const rightShapePath: IPoint2d[] = [];
  rightShapePath.push({ x: width / 2 - FAN_THICKNESS, y: 0 });
  rightShapePath.push({ x: width / 2, y: 0 });
  rightShapePath.push({ x: width / 2, y: width / 2 });
  rightShapePath.push({ x: width / 2 - FAN_THICKNESS, y: width / 2 });
  specificOutline.push(rightShapePath);

  return specificOutline;
}

export function getMotherDoorSpecificOutline(width: number) {
  const specificOutline: IPoint2d[][] = [];
  const leftShapePath: IPoint2d[] = [];
  leftShapePath.push({ x: -width / 2 + FAN_THICKNESS, y: 0 });
  leftShapePath.push({ x: -width / 2, y: 0 });
  leftShapePath.push({ x: -width / 2, y: width * 0.3 });
  leftShapePath.push({ x: -width / 2 + FAN_THICKNESS, y: width * 0.3 });
  specificOutline.push(leftShapePath);

  const rightShapePath: IPoint2d[] = [];
  rightShapePath.push({ x: width / 2 - FAN_THICKNESS, y: 0 });
  rightShapePath.push({ x: width / 2, y: 0 });
  rightShapePath.push({ x: width / 2, y: width * 0.7 });
  rightShapePath.push({ x: width / 2 - FAN_THICKNESS, y: width * 0.7 });
  specificOutline.push(rightShapePath);

  return specificOutline;
}

export function getDoorWindowSpecificOutline(type: EDoorWindowType, width: number) {
  let specificOutline: IPoint2d[][] = [];
  switch (type) {
    case EDoorWindowType.singleDoor:
      specificOutline = getSingleDoorSpecificOutline(width);
      break;
    case EDoorWindowType.doubleDoor:
      specificOutline = getDoubleDoorSpecificOutline(width);
      break;
    case EDoorWindowType.motherDoor:
      specificOutline = getMotherDoorSpecificOutline(width);
      break;
    default:
      break;
  }

  return specificOutline;
}

export function getDoorArcOutline(type: EDoorWindowType, width: number) {
  const arcOutline: IPoint2d[][] = [];
  if (type === EDoorWindowType.singleDoor) {
    const radius = width - 3;
    const outline: IPoint2d[] = [];
    const segments = 16;
    for (let i = 0; i <= segments; i++) {
      const angle = ((i / segments) * Math.PI) / 2 + Math.PI / 2;
      outline.push({
        x: Math.cos(angle) * radius + radius / 2,
        y: Math.sin(angle) * radius
      });
    }
    outline.reverse();

    arcOutline.push(outline);
  } else if (type === EDoorWindowType.doubleDoor) {
    const radius = width / 2 - 3;
    const segments = 16;

    const leftOutline: IPoint2d[] = [];
    for (let i = 0; i <= segments; i++) {
      const angle = ((i / segments) * Math.PI) / 2;
      leftOutline.push({
        x: Math.cos(angle) * radius - radius,
        y: Math.sin(angle) * radius
      });
    }
    leftOutline.reverse();
    arcOutline.push(leftOutline);

    const rightOutline: IPoint2d[] = [];
    for (let i = 0; i <= segments; i++) {
      const angle = ((i / segments) * Math.PI) / 2 + Math.PI / 2;
      rightOutline.push({
        x: Math.cos(angle) * radius + radius,
        y: Math.sin(angle) * radius
      });
    }
    rightOutline.reverse();

    arcOutline.push(rightOutline);
  } else if (type === EDoorWindowType.motherDoor) {
    const leftRadius = width * 0.3 - 3;
    const segments = 16;

    const leftOutline: IPoint2d[] = [];
    for (let i = 0; i <= segments; i++) {
      const angle = ((i / segments) * Math.PI) / 2;
      leftOutline.push({
        x: Math.cos(angle) * leftRadius - width / 2,
        y: Math.sin(angle) * leftRadius
      });
    }
    leftOutline.reverse();
    arcOutline.push(leftOutline);

    const rightRadius = width * 0.7 - 3;
    const rightOutline: IPoint2d[] = [];
    for (let i = 0; i <= segments; i++) {
      const angle = ((i / segments) * Math.PI) / 2 + Math.PI / 2;
      rightOutline.push({
        x: Math.cos(angle) * rightRadius + width / 2,
        y: Math.sin(angle) * rightRadius
      });
    }
    rightOutline.reverse();

    arcOutline.push(rightOutline);
  }

  return arcOutline;
}
